<!--
     <BPIdLayout
       :key="chartview"
       :layout="layout"
       :objects="objects"
     >
       <template v-slot="element" :data="data">
         <pre> {{ data }} </pre>
       </template>
     </BPIdLayout>
-->

<template>
  <div
    :class="'bpidl-cont ' + layout.direction"
  >
    <div
      class="bpidl-elem"
      v-for="node in iter_style"
      :style="node.style"
    >
      <!-- <span>{{ JSON.stringify(node) }}</span> -->
      <div
        v-if="node.node == 'id'"
        :style="node.cont_style"
      >
        <slot
          name="element"
          :data="objects[node.content]"
        > 
          {{ $vuetify.lang.translator('explorer.no_data') }}
      </slot>
      </div>

      <BPIdLayout
        v-if="node.node == 'layout'"
        :layout="node.content"
        :objects="objects"
      >
        <template v-slot:element="{ data }">
          <slot name="element" :data="data">
            {{ $vuetify.lang.translator('explorer.no_data') }}
          </slot>
        </template>
      </BPIdLayout>
    </div>
  </div>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .bpidl-cont {
   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   min-height: 100px;
   overflow-y: hidden;
   padding: 0px;
 }

 .bpidl-cont.v {
   flex-direction: column;
 }

 .bpidl-cont.h {
   flex-direction: row;
 }

 .bpidl-elem {
   width: 100%;
 }

 @media all and (orientation:portrait) {
   .bpidl.h {
     flex-direction: column;
   }
 }
</style>

<script>
 export default {
   name: 'BPIdLayout',

   components: {
     
   },

   props: {
     objects: {required: true},
     layout: {required: true},
     style_props: {required: false}, // {gap: 10}
   },

   data: (() => ({
     // data (:
   })),

   methods: {
   },

   computed: {
     gap() {
       return (this.style_props||{}).gap || 10;
     },

     iter_style() {
       const gap = this.gap;

       function get_width(c) {
         return (c.node == 'layout') ? (c.content.size || 100) : 100;
       }

       return this.layout.content.map(c => ({
         ...c,
         style: `width: ${get_width(c)}%;`,
         cont_style: `width: 100%; padding: ${this.gap}px`,
       }));
     }
   },
 };
</script>
